<template>
    <div>
        <el-dialog
            custom-class="codelab-popper codelab-add-family-nickname youtube-add-content-custom"
            title="Youtube"
            :visible.sync="centerDialogVisible"
            width="513px"
            center>
            <div>
                <p class="discrip">{{ $t('youtube_dialog_message.title') }}</p>
                <p class="inputClass">
                    <el-input type="text" v-model="url" />
                </p>
                <p class="discripUrl">{{ $t('youtube_dialog_message.discrip') }}: https://www.youtube.com/watch?v=Nf1C1fSJG_8</p>
                <p class="remarksDesc">*{{ $t('youtube_dialog_message.remarks') }}</p>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="() => {
                    centerDialogVisible = false
                }">{{ $t('youtube_dialog_message.cancel') }}</el-button>
                <el-button type="primary" @click="confirmSendUrl">{{ $t('youtube_dialog_message.confirm') }}</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<style lang="scss">
    .youtube-add-content-custom {
        .el-dialog__body {
            padding: 25px 31px 15px 46px!important;
        }
        .el-dialog__header {
            font-size: 18px;
            font-weight: 500;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            letter-spacing: 1px;
            color: #c8c8c8;
        }

        .remarksDesc {
            font-size: 12px;
            font-weight: 500;
            color: #ffffff;
            line-height: 1.83;
            margin-top: 5px;
            max-height: 44px;
        }

        .inputClass {
            display: flex;
            align-items: center;
            justify-content: space-between;
            color: #ffffff;
        }
        .discrip {
            color: #ffffff;
            margin-bottom: 14px;
        }
        .discripUrl {
            color: #ffffff;
            margin-top: 10px;
            font-size: 12px;
            font-weight: 500;
            line-height: 1.83;
            letter-spacing: 0.86px;
            color: #a8a8ac;
            user-select: text;
            -moz-user-select : text;
            -webkit-user-select: text;
            cursor: text;
            opacity: .6;
        }
        .el-input {
            .el-input__inner {
                background-color: transparent;
                padding: 0px 14px;
                height: 35px;
                line-height: 35px;

                font-size: 14px;
                font-weight: 500;
                font-stretch: normal;
                font-style: normal;
                line-height: normal;
                letter-spacing: 1px;
                color: #0ed3ff;
            }
        }

        .el-dialog__footer {
            padding-top: 0px;
            padding-bottom: 30px;
            width: 90%;
            margin: auto;
            .dialog-footer {
                display: flex;
                justify-content: space-around;
            }
            .el-button--primary {
                border-color: #00b5e2;
                background-color: #00b5e2;
            }
            .el-button--default {
                border-color: #727272;
                color: #ffffff;
                background-color: #727272;
            }
            .el-button {
                height: 42px;
                line-height: 42px;
                font-size: 16px;
                padding: 0px 10px;
                min-width: 110px;
                border-radius: 24px;
            }
        }
    }
</style>

<script>
  export default {
    data () {
      return {
        centerDialogVisible: false,
        url: ''
      };
    },
    computed: {
        cpUrl () {
            const url = this.url.replace(/\s/, '').trim()
            if (!/(http|https):\/\/(www.)?(youtube.com|youtu.be)/ig.test(url)) return { v: url }
            const url_ = url.toLowerCase()
            let watchS = 'watch?', embedS = 'embed/', be = 'youtu.be/'
            let data, indexWatch = url_.indexOf(watchS)
            , indexEmbed = url_.indexOf(embedS), indexBe = url_.indexOf(be)
            function baseParamsSplit (vars) {
                let data = {}
                for (let i = 0; i < vars.length; i++) {
                    let pair = vars[i].split("=")
                    data[pair[0]] = pair[1]
                }
                return data
            }
            if (indexWatch > -1) {
                let handleArrStr = url.slice(indexWatch + watchS.length).split('&')
                if (handleArrStr.length) {
                    data = baseParamsSplit(handleArrStr)
                }
            } else if (indexEmbed > -1) {
                let indexSearch = url.indexOf('?')
                let v = url.slice(indexEmbed + embedS.length, indexSearch)
                let handleArrStr = url.slice(indexSearch + 1).split('&')
                if (handleArrStr.length) {
                    data = { ...baseParamsSplit(handleArrStr), v }
                }
            } else if (indexBe > -1) {
                let indexSearch = url.indexOf('?')
                let v = indexSearch < 0 ? url.slice(indexBe + be.length) : url.slice(indexBe + be.length, indexSearch)
                if (indexSearch > 0) {
                    let handleArrStr = url.slice(indexSearch + 1).split('&')
                    if (handleArrStr.length) {
                        data = { ...baseParamsSplit(handleArrStr), v }
                    }
                } else {
                    data = { v }
                }
            } else {
                data = { v: url }
            }
            return data
        }
        // cpUrlw () {
        //     const url = this.url.replace(/\s/, '').trim()
        //     let watchS = 'watch?', embedS = 'embed/'
        //     let data, indexWatch = url.indexOf(watchS), indexEmbed = url.indexOf(embedS)
        //     function baseParamsSplit (vars) {
        //         let data = {}
        //         for (let i = 0; i < vars.length; i++) {
        //             let pair = vars[i].split("=")
        //             data[pair[0]] = pair[1]
        //         }
        //         return data
        //     }
        //     if (indexWatch > -1) {
        //         let handleArrStr = url.slice(indexWatch + watchS.length).split('&')
        //         if (handleArrStr.length) {
        //             data = baseParamsSplit(handleArrStr)
        //         }
        //     } else if (indexEmbed > -1) {
        //         let indexSearch = url.indexOf('?')
        //         let v = url.slice(indexEmbed + embedS.length, indexSearch)
        //         let handleArrStr = url.slice(indexSearch + 1).split('&')
        //         if (handleArrStr.length) {
        //             data = { ...baseParamsSplit(handleArrStr), v }
        //         }
        //     } else {
        //         data = { v: url }
        //     }
        //     return data
        // }
    },
    methods: {
        open () {
            this.centerDialogVisible = true
        },
        confirmSendUrl () {
            console.log('未輸入Youtube網址！', this.cpUrl.v)
            if (!this.cpUrl.v) {
                this.$message.warning(this.$t('youtube.input_url_warning'))
            }
            this.$emit('parentEventGetUrl', this.cpUrl.v)
            this.centerDialogVisible = false
            this.url = ''
        },
    }
  }
</script>
